import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMembership } from '../../hooks/MembershipProvider/MembershipProvider';

interface AdminGuardProps {
  children: React.ReactNode;
  // 필요한 권한 레벨을 지정할 수 있습니다
  requiredPermission?: 'admin' | 'manager' | 'system';
}

const AdminGuard: React.FC<AdminGuardProps> = ({ 
  children, 
  requiredPermission = 'admin' 
}) => {
  const { 
    isAuthenticated, 
    hasAdminPermission, 
    hasManagerPermission, 
    hasSystemPermission 
  } = useMembership();

  // 로그인 상태 확인
  if (!isAuthenticated) {
    // return <Navigate to="/login" replace />;
    return (<></>)
  }

  // 권한 확인
  const hasPermission = () => {
    switch (requiredPermission) {
      case 'admin':
        return hasAdminPermission();
      case 'manager':
        return hasManagerPermission() || hasAdminPermission();
      case 'system':
        return hasSystemPermission() || hasAdminPermission();
      default:
        return hasAdminPermission();
    }
  };

  if (!hasPermission()) {
    return (<></>)
    // 권한이 없으면 홈페이지로 리다이렉트
    // return <Navigate to="/" replace />;
  }
  


  return <>{children}</>;
};

export default AdminGuard;
